export const API_SERVER = "http://localhost:5000/api/";